import Vue from 'vue';

//helper app
import './Components/Helpers/HelperComponent';

/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);
Vue.component('message', require('./Components/Views/Auth/PersonalInformation').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);




/**
 *
 * Custom components for Candidate
 *
 */


// Talentpool, Hiring and Onboarding datatable
Vue.component('app-hiring', require('./Components/Views/Candidate/Tables/Hiring').default);
Vue.component('app-talentpool', require('./Components/Views/Candidate/Tables/Talentpool').default);
Vue.component('app-onboarding', require('./Components/Views/Candidate/Tables/Onboarding').default);


// Shared components (modals) among Talentpool, Hiring and Onboarding
Vue.component('app-candidate-add-modal', require('./Components/Views/Candidate/Tables/candidate/AddModal').default);
Vue.component('app-share-modal', require('./Components/Views/Candidate/Tables/share/Modal').default);
Vue.component('app-message-modal', require('./Components/Views/Candidate/Tables/message/Modal').default);
Vue.component('app-rejection-modal', require('./Components/Views/Candidate/Tables/rejection/Modal').default);
Vue.component('app-schedule-modal', require('./Components/Views/Candidate/Tables/schedule/Modal').default);
Vue.component('app-alert-modal', require('./Components/Views/Candidate/Tables/alert/Modal').default);
Vue.component('app-pay-modal', require('./Components/Views/Candidate/Tables/pay/Modal').default);
Vue.component('app-delete-demo-modal', require('./Components/Views/Candidate/Tables/delete-demo/Modal').default);
Vue.component('app-history', require('./Components/Views/Candidate/Tables/history/History').default);


// Shared components (datatables) among Talentpool, Hiring and Onboarding
Vue.component('app-attachment', require('./Components/Views/Candidate/Tables/file/ListView').default);
Vue.component('app-attachment-upload-form', require('./Components/Views/Candidate/Form/form-elements/components/FormMultipleFiles').default);

Vue.component('app-comment-add-form', require('./Components/Views/Candidate/Form/form-elements/components/FormComment').default);
Vue.component('app-comment', require('./Components/Views/Candidate/Tables/comment/CommentView').default);
Vue.component('app-comment-latest', require('./Components/Views/Candidate/Tables/comment/CommentLatest').default);
Vue.component('app-mailbox-add-form', require('./Components/Views/Candidate/Form/form-elements/components/FormMailbox').default);
Vue.component('app-mailbox', require('./Components/Views/Candidate/Tables/mailbox/MailboxView').default);

// Shared components (forms) among Talentpool, Hiring, Onboarding, Career and Onboarding sites
Vue.component('form-editor-files', require('./Components/Views/Candidate/Form/form-elements/components/FormEditorFiles').default);

// Shared components (forms) among Talentpool, Hiring, Onboarding, Career and Onboarding sites
// MainTabs (2nd level "button style" navigation) and timeline navigation
Vue.component('app-main-tabs', require('./Components/Views/Layouts/MainTabs').default);


// Career
Vue.component('app-career', require('./Components/Views/Career/Tables/Career').default);
Vue.component('app-career-templates', require('./Components/Views/Career/Tables/CareerTemplates').default);
Vue.component('app-career-add-modal', require('./Components/Views/Career/Tables/career/AddModal').default);

// CareerSite
Vue.component('app-career-site', require('./Components/Views/CareerSite/Form/form-elements/FormElements').default);
Vue.component('app-career-site-editor', require('./Components/Views/CareerSite/Form/form-elements/components/Editor').default);
Vue.component('app-public-career-site', require('./Components/Views/CareerSite/Form/form-elements/components/PublicCareerSite').default);

// OnboardingSite
Vue.component('app-onboarding-site', require('./Components/Views/OnboardingSite/Form/form-elements/FormElements').default);
Vue.component('app-onboarding-site-editor', require('./Components/Views/OnboardingSite/Form/form-elements/components/Editor').default);
Vue.component('app-employee-dashboard', require('./Components/Views/OnboardingSite/Dashboard/Dashboard').default);
Vue.component('app-employee-wiki', require('./Components/Views/OnboardingSite/Dashboard/Wiki').default);
Vue.component('app-employee-latest', require('./Components/Views/OnboardingSite/Form/form-elements/Latest').default);

// Course
Vue.component('app-course', require('./Components/Views/Course/Tables/Course').default);
Vue.component('app-course-add-modal', require('./Components/Views/Course/Tables/course/AddModal').default);
Vue.component('app-course-attachment', require('./Components/Views/Course/Tables/file/ListView').default);
Vue.component('app-form-attachment', require('./Components/Views/Form/Tables/file/ListView').default);

// Onboarding Checklists
Vue.component('app-checklist-add-form', require('./Components/Views/Candidate/Form/form-elements/components/FormChecklist').default);
Vue.component('app-checklist-edit-form', require('./Components/Views/Candidate/Tables/checklist/ChecklistView').default);
Vue.component('app-checklist', require('./Components/Views/Candidate/Tables/Checklist').default);
Vue.component('app-checklist-form', require('./Components/Views/Candidate/Form/ChecklistForm').default);

// Forms (quiz, feedback and etc.)
Vue.component('app-quiz', require('./Components/Views/Form/Tables/Quiz').default);
Vue.component('app-feedback', require('./Components/Views/Form/Tables/Feedback').default);
Vue.component('app-message', require('./Components/Views/Form/Tables/EntryQuestionnaire').default);
Vue.component('app-document', require('./Components/Views/Form/Tables/Document').default);
Vue.component('app-form-add-modal', require('./Components/Views/Form/Tables/form/AddModal').default);
Vue.component('app-employee-list', require('./Components/Views/Form/Tables/form/EmployeeListView').default);
Vue.component('app-result-list', require('./Components/Views/Form/Tables/form/ResultListView').default);
Vue.component('app-form-items', require('./Components/Views/Form/Tables/form/FormItems').default);
Vue.component('app-form', require('./Components/Views/Form/Tables/form/Form').default);
Vue.component('app-form-add-result', require('./Components/Views/Form/Tables/form/AddResult').default);

// Templates
Vue.component('app-mail-template', require('./Components/Views/Template/Tables/MailTemplate').default);
Vue.component('app-template-add-modal', require('./Components/Views/Template/Tables/template/AddModal').default);

// Help
Vue.component('app-guide', require('./Components/Views/Guide/Guide').default);




// Forms
Vue.component('form-layouts', require('./Components/Views/Candidate/Form/form-layouts/FormLayouts').default);
Vue.component('form-grid', require('./Components/Views/Candidate/Form/form-layouts/components/FormGrid').default);
Vue.component('form-row', require('./Components/Views/Candidate/Form/form-layouts/components/FormRow').default);
Vue.component('form-horizontal', require('./Components/Views/Candidate/Form/form-layouts/components/HorizontalForm').default);
Vue.component('form-validation', require('./Components/Views/Candidate/Form/form-validation/FormValidationIndex').default);
Vue.component('form-validation-required', require('./Components/Views/Candidate/Form/form-validation/component/FormValidationRequired').default);
Vue.component('form-validation-range', require('./Components/Views/Candidate/Form/form-validation/component/FormRangeValidation').default);
Vue.component('input-text', require('./Components/Views/Candidate/Form/InputText').default);
Vue.component('multiple-form-files-fields', require('./Components/Views/Candidate/Form/form-elements/components/FormMultipleFiles').default);


// All input forms
Vue.component('all-form-inputs', require('./Components/Views/Candidate/Form/form-elements/FormElements').default);
Vue.component('form-input-fields', require('./Components/Views/Candidate/Form/form-elements/components/FormInput').default);
Vue.component('form-date-time-fields', require('./Components/Views/Candidate/Form/form-elements/components/FormDateTimePIcker').default);
Vue.component('form-multi-select-fields', require('./Components/Views/Candidate/Form/form-elements/components/FormMultiSelect').default);
Vue.component('form-radio-fields', require('./Components/Views/Candidate/Form/form-elements/components/FormRadio').default);
Vue.component('form-files-fields', require('./Components/Views/Candidate/Form/form-elements/components/FormFiles').default);


// Dashboard
Vue.component('dashboard-default', require('./Components/Views/Demo/Dashboard/Default').default);



// Testing only?
Vue.component('app-candidate-crud', require('./Components/Views/Candidate/Tables/candidate/Index').default);
